module.exports = __webpack_public_path__ + "06_medium_gray.d52bc864.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/06_medium_gray.png
// module id = U//3
// module chunks = 0